// src/api/auth.js
import http from "./http";

export function loginApi(username, password) {
    return http.post("/api/player/auth/login", { username, password });
}

export function registerApi({ username, password, confirmPassword, currency = "KHR" }) {
    return http.post("/api/player/auth/register", {
        username,
        password,
        confirmPassword,
        currency
    });
}

export function checkUsernameApi(username) {
    return http.get("/api/player/auth/check-username", {
        params: { username }
    });
}
